import React from 'react';
import { Text, StyleSheet } from 'react-native';
import { IconSetRegular, IconSetFill, IconSetBold } from "../fonts/PhosphorIcons/PhosphorIcons";
// False negative PropType warnings are a headache in dev
// @ts-ignore
IconSetRegular.propTypes = undefined;
// @ts-ignore
IconSetFill.propTypes = undefined;
// @ts-ignore
IconSetBold.propTypes = undefined;
// @ts-ignore
Text.propTypes = global.__ENABLE_PROPTYPES__ ? Text.propTypes : undefined;
const IconWrapper = (props) => {
    const { name, style } = props;
    const { height, ...iconStyle } = StyleSheet.flatten(style ?? {});
    // UI Kitten button expects Icons to be an <Image> (where tintColor is valid)
    // Since we're using a 3rd party adapter, it renders as <Text> component
    // So we can map tintColor -> color to achieve the same thing
    // @ts-ignore
    const convertTintToColor = iconStyle.tintColor
        // @ts-ignore
        ? { color: iconStyle.color || iconStyle.tintColor }
        : {};
    // All available weights in the library
    const allWeights = ['fill', 'bold', 'regular', 'thin', 'light', 'duotone'];
    // Currently supported weights
    const supportedWeights = ['fill', 'bold', 'regular'];
    // IconSet mapping for supported weights
    const iconSetMap = {
        'fill': IconSetFill,
        'bold': IconSetBold,
        'regular': IconSetRegular,
    };
    // Split the name by '-' to handle kebab-case
    const nameParts = name.split('-');
    const weightSuffix = nameParts[nameParts.length - 1];
    // Check if the weight suffix is a valid weight
    const isValidWeight = allWeights.includes(weightSuffix);
    const isSupportedWeight = supportedWeights.includes(weightSuffix);
    // Show warning for unsupported weights
    if (isValidWeight && !isSupportedWeight) {
        console.warn(`Icon weight "${weightSuffix}" is not yet supported. ` +
            `Supported weights: ${supportedWeights.join(', ')}. ` +
            'Falling back to "regular".');
    }
    // Determine which IconSet to use
    const IconSet = isSupportedWeight ? iconSetMap[weightSuffix] : IconSetRegular;
    const iconName = isValidWeight ? nameParts.slice(0, -1).join('-') : name;
    return (<IconSet name={iconName} size={height} 
    // @ts-ignore
    style={[iconStyle, convertTintToColor]}/>);
};
const IconProvider = (name) => ({
    toReactElement: (props) => IconWrapper({ name, ...props }),
});
function createIconsMap() {
    return new Proxy({}, {
        get(target, name) {
            return IconProvider(name);
        },
    });
}
export const IconPack = {
    name: 'materialCommunity',
    icons: createIconsMap(),
};
export default IconPack;
//# sourceMappingURL=adapter.js.map